import { ConditionParams } from "Global/Base/DataSources/Interfaces";
import { DropDownMenuItem } from "../../../../../UI.Controls/DropDownMenu/DropDownMenuItem";
import { registerCustomElement } from "../../../../../UI.ElementarControls/Utils/CustomElementUtils";
import { CaseInsensitiveMap } from "../../../../../UI.React/types/multiweb";
import { FrameContext } from "../../../UIManagerInterfaces";
import { ValueList } from "../AdvancedFilters/ValueList";

export class DropDownMenuCheckedDGItem extends DropDownMenuItem {
    public isClickable: boolean = false;
    private _dgElement: ValueList;

    public get valueList(): ValueList {
        return this._dgElement;
    }

    protected override _constructor(): void {
        super._constructor();
    }

    protected override _createElement(): void {
        this.classList.add("DropDownMenuItem", "CheckedDataGridItem");
        this._textElement = document.createElement("div");
        this._textElement.innerHTML = "";
        this._dgElement = new ValueList();

        this.appendChild(this._dgElement);
        this._setListener();
    }

    public init(className: string, Attrs: Array<string>, frameContext: FrameContext, frameCondition?: string, frameConditionParams?: ConditionParams, _disableValueShortening?: boolean, attrDataTypes?: CaseInsensitiveMap<string>): void {
        this._dgElement.initialize(className, Attrs, frameContext, frameCondition, frameConditionParams, undefined, attrDataTypes);
    }

    protected override _setListener(): void {
        this.registerEventListener("click", (e: MouseEvent) => {
            if (e.button === 0) {
                e.stopImmediatePropagation();
            }
        });
    }

    public override dispose(): void {
        super.dispose();
    }
}

registerCustomElement("tsc-DropDownMenuCheckedDGItem", DropDownMenuCheckedDGItem);
